export default "__VITE_ASSET__3c7ebfd6__"